import React, { useEffect, useMemo, useState } from "react";
import Container from "../../components/Layout/Container";
import ContentBlock from "../../components/Layout/ContentBlock";
import HamlSnippet from "../../components/globals/HamlSnippet";

function CategoryAttributeMapPage({ match }) {

  return (
    <Container
          location={{
            locationName: "Category Attribute Map",
            locationUrl: match.url,
          }}
        >
        <HamlSnippet url="/front/options/category_attribute_maps" />
    </Container>
  );
}

export default CategoryAttributeMapPage;